import{
    IMPORT_ACCOUNT_SOURCE_MIGRATION_OPEN_MODAL,
    IMPORT_ACCOUNT_SOURCE_MIGRATION_CLOSE_MODAL
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    accountsList: [],
    account: null,
    loading: false,
    result: null,
    status: null,
    pxAccount: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case IMPORT_ACCOUNT_SOURCE_MIGRATION_OPEN_MODAL:
            return { ...state, openModal: action.payload }
            
        default:
            return state;
    }
};
